import type { Category } from "@api/getcategories";
import type { Region } from "@api/getregions";
import { CategorySearch, LocationSearch } from "@components/Select";
import React, { useCallback, useState } from "react";
import scss from './SearchPopup.module.scss'
import { Button } from 'react-bootstrap';


function SearchForm() {

  const [currentRegion, setCurrentRegion] = useState<Region | null>(null);
  const [currentCategory, setCurrentCategory] = useState<Category | null>(null);

  const findSuppliers = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    var url: string = "\\" + (currentCategory?.Slug ?? "wedding") + "\\" + (currentRegion?.Slug ?? "") + (currentRegion ? "\\" : "");
    window.location.href = url;
  }, [currentCategory, currentRegion]);

  return (<form className={scss.form}>
    <div className={scss.formRow}>
      <CategorySearch currentCategory={currentCategory} setCurrentCategory={setCurrentCategory} />
    </div>

    <div className={scss.formRow}>
      <LocationSearch currentRegion={currentRegion} setCurrentRegion={setCurrentRegion} />
    </div>

    <Button variant="primary" className={scss.searchButton} onClick={findSuppliers}>Find Suppliers</Button>
  </form>)
}

export default SearchForm
